import React from 'react';
import { Clock3Icon, MapPinIcon, PackageCheckIcon } from 'lucide-react';
interface NowDeliveryPromiseProps {
  compact?: boolean;
  availability?: 'available' | 'low-stock' | 'tomorrow';
}
const availabilityCopy = {
  available: {
    label: 'Available for chilled delivery',
    detail: 'Delivered within 120 min',
    className: 'bg-brand-light text-brand'
  },
  'low-stock': {
    label: 'Limited stock nearby',
    detail: 'Reserve your 120-minute slot now',
    className: 'bg-promo-light text-[#A95712]'
  },
  tomorrow: {
    label: 'Available tomorrow',
    detail: '120-minute delivery is not available for this address today',
    className: 'bg-gray-100 text-brand-muted'
  }
} as const;
export function NowDeliveryPromise({
  compact = false,
  availability = 'available'
}: NowDeliveryPromiseProps) {
  const promise = availabilityCopy[availability];
  if (compact) {
    return <span className={`inline-flex items-center gap-1 rounded-full px-2 py-1 text-[10px] font-bold ${promise.className}`} data-id="element-4386" data-mp="yzqgkqkcdny2">
        <Clock3Icon className="h-3 w-3" aria-hidden="true" data-id="element-4387" data-mp="2xonuj6t9ivq7" /> {availability === 'available' ? 'Chilled 120' : promise.label}
      </span>;
  }
  return <section className="rounded-xl border border-brand-border bg-brand-light p-3.5" aria-label="Chilled 120-minute delivery promise" data-id="element-4388" data-mp="32pbtcenqgguz">
      <div className="flex items-start gap-3" data-id="element-4389" data-mp="2spkz8e3343vf">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand text-white" data-id="element-4390" data-mp="2sqmdssjb78hw">
          {availability === 'available' ? <Clock3Icon className="h-5 w-5" aria-hidden="true" data-id="element-4391" data-mp="3ghhy74lfr1f4" /> : <PackageCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-4392" data-mp="3ld721k4hn4h8" />}
        </span>
        <div className="min-w-0 flex-1" data-id="element-4393" data-mp="36q45pgrwj1vh">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-4394" data-mp="36p2hsbpsekwc">
            <p className="text-sm font-bold text-brand-ink" data-id="element-4395" data-mp="3bndt6qvqd3go">{promise.label}</p>
            <span className="text-brand-muted" aria-hidden="true" data-id="element-4396" data-mp="383w5x6p6ofr">·</span>
            <p className="text-sm font-bold text-brand" data-id="element-4397" data-mp="7zc40osdq1qt">{promise.detail}</p>
          </div>
          <p className="mt-1 flex items-center gap-1 text-xs leading-4 text-brand-muted" data-id="element-4398" data-mp="816ra9r4i5y2"><MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-4399" data-mp="huj9ynmxtgm9" /> Based on your selected delivery address.</p>
        </div>
      </div>
    </section>;
}